import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createPersistedState } from 'pinia-plugin-persistedstate'
import { createHead } from '@vueuse/head'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'uno.css'
import './style.css'

import App from './App.vue'
import router from './router'
import { setupAutoImports } from './utils/auto-imports'
import { setupVisitTracking } from './plugins/visitTracking'

// 创建应用实例
const app = createApp(App)

// 创建 Pinia 实例
const pinia = createPinia()
const head = createHead()

// 配置状态持久化
pinia.use(createPersistedState())

// 注册插件
app.use(pinia)
app.use(router)
app.use(head)
app.use(ElementPlus)

// 设置访问统计
setupVisitTracking(app, router)

// 设置自动导入
setupAutoImports(app)

// 挂载应用
app.mount('#app')